import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://34.192.63.227:8001";

export default function LiveAccess() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.detail || "Invalid credentials");
      }

      const data = await res.json();

      localStorage.setItem("FENTASAFE_TOKEN", data.access_token || "");
      localStorage.setItem("FENTASAFE_ROLE", data.role || "CUSTOMER_USER");
      localStorage.setItem(
        "FENTASAFE_USER",
        JSON.stringify({
          email,
          role: data.role || "CUSTOMER_USER",
          access_level: "LIVE",
          data_source: "LIVE",
        })
      );

      navigate("/live/dashboard");
    } catch (err) {
      setError(err.message || "Login failed. Please check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>

        {/* LOCK ICON */}
        <div style={styles.lockIcon}>🔒</div>

        <h1 style={styles.title}>FentaSafe Live Access</h1>
        <p style={styles.subtitle}>Secure Access Portal</p>
        <p style={styles.description}>
          Restricted operational access for authorized monitoring facilities
          with real-time sensor intelligence.
        </p>

        {/* LOGIN FORM */}
        <form onSubmit={handleLogin} style={styles.form}>
          <input
            type="email"
            placeholder="your@fentasafe.org"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
            required
            autoComplete="email"
          />

          <input
            type="password"
            placeholder="••••••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
            required
            autoComplete="current-password"
          />

          {error && (
            <div style={styles.errorBox}>
              ⚠️ {error}
            </div>
          )}

          <button
            type="submit"
            style={{
              ...styles.button,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
            }}
            disabled={loading}
          >
            {loading ? "Authenticating..." : "Access Live Dashboard"}
          </button>
        </form>

        {/* LIVE DATA NOTICE — correct messaging for paid users */}
        <div style={styles.liveNotice}>
          <span style={styles.liveIndicator}>🟢</span>
          <span>
            Live sensor data — real-time environmental intelligence from
            your deployed monitoring environment.
          </span>
        </div>

        {/* SECURITY NOTE */}
        <p style={styles.securityNote}>
          🔐 Secure access with role-based permissions.
          Contact <a href="mailto:contact@fentasafe.org" style={styles.link}>
            contact@fentasafe.org
          </a> to request access.
        </p>

      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "calc(100vh - 80px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#0f172a",
    padding: "40px 20px",
  },

  card: {
    background: "#0d1b2e",
    border: "1px solid #1e3a5f",
    borderRadius: 16,
    padding: "40px 36px",
    width: "100%",
    maxWidth: 440,
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
  },

  lockIcon: {
    fontSize: "2.5rem",
    marginBottom: 12,
  },

  title: {
    fontSize: "1.6rem",
    fontWeight: 700,
    color: "#ffffff",
    marginBottom: 6,
    fontFamily: "monospace",
    letterSpacing: "1px",
  },

  subtitle: {
    color: "#64748b",
    fontSize: "0.85rem",
    marginBottom: 12,
    textTransform: "uppercase",
    letterSpacing: "2px",
  },

  description: {
    color: "#94a3b8",
    fontSize: "0.9rem",
    lineHeight: 1.6,
    marginBottom: 24,
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginBottom: 16,
  },

  input: {
    padding: "12px 16px",
    borderRadius: 8,
    border: "1px solid #1e3a5f",
    background: "#0f172a",
    color: "#ffffff",
    fontSize: "0.95rem",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },

  button: {
    padding: "13px",
    background: "#16a34a",
    border: "none",
    borderRadius: 8,
    color: "#ffffff",
    fontSize: "1rem",
    fontWeight: 700,
    marginTop: 4,
    transition: "opacity 0.2s",
  },

  errorBox: {
    background: "rgba(239, 68, 68, 0.1)",
    border: "1px solid rgba(239, 68, 68, 0.3)",
    borderRadius: 8,
    padding: "10px 14px",
    color: "#fca5a5",
    fontSize: "0.85rem",
    textAlign: "left",
  },

  liveNotice: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
    background: "rgba(22, 163, 74, 0.08)",
    border: "1px solid rgba(22, 163, 74, 0.25)",
    borderRadius: 8,
    padding: "10px 14px",
    fontSize: "0.82rem",
    color: "#86efac",
    textAlign: "left",
    marginBottom: 16,
    lineHeight: 1.5,
  },

  liveIndicator: {
    fontSize: "0.7rem",
    marginTop: 2,
    flexShrink: 0,
  },

  securityNote: {
    color: "#475569",
    fontSize: "0.78rem",
    lineHeight: 1.6,
  },

  link: {
    color: "#60a5fa",
    textDecoration: "none",
  },
};
